import { Grid, MenuItem, TextField } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Dayjs } from 'dayjs';
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { getCompanyFunds } from '../../api/funds';

export interface Fund {
  id: string;
  name: string;
}

export interface FiltersProps {
  selectedFund: string | undefined;
  onFundChange: (fund: string | undefined) => void;
  startDate: Dayjs;
  onStartDateChange: (date: Dayjs) => void;
  endDate: Dayjs;
  onEndDateChange: (date: Dayjs) => void;
}

export const Filters: React.FC<FiltersProps> = ({
  selectedFund,
  onFundChange,
  startDate,
  onStartDateChange,
  endDate,
  onEndDateChange,
}) => {
  const dispatch = useDispatch();
  const { data } = getCompanyFunds(dispatch);
  const fundOptions = useMemo(
    () =>
      data?.map((fund: Fund) => ({
        value: fund.id,
        label: `${fund.name} (${fund.id})`,
      })),
    [data],
  );

  return (
    <Grid container spacing={1.5} sx={{ px: 3 }}>
      <Grid item xs={12} sm={4}>
        <TextField
          select
          fullWidth
          size="small"
          label="Fondo"
          value={selectedFund ?? ''}
          onChange={(e) => onFundChange(e.target.value || undefined)}
          sx={{
            '& .MuiOutlinedInput-root': {
              height: 40,
            },
          }}
        >
          <MenuItem value="" disabled>
            Seleccionar fondo
          </MenuItem>
          {fundOptions?.map((fund) => (
            <MenuItem key={fund.value} value={fund.value}>
              {fund.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={4}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Fecha Inicial"
            value={startDate}
            onChange={(date) => date && onStartDateChange(date)}
            maxDate={endDate}
            slotProps={{
              textField: {
                fullWidth: true,
                size: 'small',
                sx: {
                  '& .MuiOutlinedInput-root': {
                    height: '40px',
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} sm={4}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Fecha Final"
            value={endDate}
            onChange={(date) => date && onEndDateChange(date)}
            minDate={startDate}
            slotProps={{
              textField: {
                fullWidth: true,
                size: 'small',
                sx: {
                  '& .MuiOutlinedInput-root': {
                    height: '40px',
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      </Grid>
    </Grid>
  );
};
